import React, { useContext } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

import { breakpoints } from "../parameters/theme"

const Container = styled.aside`
  h2 {
    font-size: 1.5em !important;
  }

  .posts {
    display: grid;
    grid-gap: 1em 1em;
    grid-template-columns: 1fr 1fr;
    margin-top: 1em;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .posts {
      display: block;
    }

    .posts .post + .post {
      margin-top: 1em;
    }
  }
`

const RelatedArticles = ({ slug, amount = 4, related }) => {
  const { allContentfulArticle } = useContext(ContentfulDataContext)

  if (!slug) {
    return null
  }

  const matchedArticles = allContentfulArticle.edges.filter(
    ({ node: article }) => {
      return article.slug === slug
    }
  )

  if (!matchedArticles || !matchedArticles.length) {
    return null
  }

  const article = matchedArticles[0].node

  // Articles of the same category with a title image to show.
  const articles = allContentfulArticle.edges.filter(({ node: art }) => {
    return (
      art.slug !== slug && art.category === article.category && art.titleImage
    )
  })

  let selectedArticles = []
  let relatedArticles = []
  if (related && related.length) {
    relatedArticles = articles.filter(({ node: art }) => {
      return related.indexOf(art.slug) > -1
    })
  }

  if (relatedArticles.length >= amount) {
    selectedArticles = relatedArticles.slice(0, amount)
  } else {
    const amountLack = amount - relatedArticles.length

    const remainingArticles = articles.filter(({ node: art }) => {
      return relatedArticles.indexOf(art.slug) < 0
    })

    // Get some random articles
    const selectedRandomIndices = []
    const minAmountPossible = Math.min(amountLack, remainingArticles.length)
    let index
    while (selectedRandomIndices.length < minAmountPossible) {
      index = Math.floor(Math.random() * Math.floor(minAmountPossible))

      if (selectedRandomIndices.indexOf(index) < 0) {
        selectedRandomIndices.push(index)
      }
    }

    const randomArticles = selectedRandomIndices.map(
      ind => remainingArticles[ind]
    )

    selectedArticles = [...relatedArticles, ...randomArticles]
  }

  if (!selectedArticles.length) {
    return null
  }

  return (
    <Container className="section-post-related">
      <h2>Related articles</h2>
      <section className="posts">
        {selectedArticles.map(({ node: article }) => (
          <div
            className="post post-cover-title post-cover-small"
            key={article.slug}
          >
            <Link to={`/${article.slug}`} title={article.title}>
              <Img
                fluid={article.titleImage.fluid}
                alt={article.titleImage.title}
              />
              <h3>{article.title}</h3>
            </Link>
          </div>
        ))}
      </section>
    </Container>
  )
}

export default RelatedArticles
